import { IndustryType } from './industry/industry-types.enum';

/**
 * Industries where Cash Denomination is turned off.
 *
 * Hides everything denomination-related for these industries: the footer button and
 * F12 shortcut, the /cash-denomination route, and the Cash In / Cash Out (opening/closing
 * cash) prompts together with their punch-status API call.
 *
 * To show denomination again for an industry, remove it from this list.
 */
export const DENOMINATION_HIDDEN_INDUSTRIES: number[] = [IndustryType.MOBILE];

export function isDenominationEnabledFor(industryId: number | string | null | undefined): boolean {
  return !DENOMINATION_HIDDEN_INDUSTRIES.includes(Number(industryId));
}

/**
 * Industries where Petty Cash is turned off.
 *
 * Removes the Petty Cash tab from Cash Management (which also stops its APIs:
 * cash/denomination?type=0|1, cash/pettycash, cash/expensetypes) and blocks /petty-cash.
 *
 * To show Petty Cash again for an industry, remove it from this list.
 */
export const PETTY_CASH_HIDDEN_INDUSTRIES: number[] = [IndustryType.MOBILE];

export function isPettyCashEnabledFor(industryId: number | string | null | undefined): boolean {
  return !PETTY_CASH_HIDDEN_INDUSTRIES.includes(Number(industryId));
}

/**
 * Industries where Loyalty is turned off.
 *
 * Hides the Loyalty column in the Sales History dialog.
 *
 * To show Loyalty again for an industry, remove it from this list.
 */
export const LOYALTY_HIDDEN_INDUSTRIES: number[] = [IndustryType.MOBILE];

/**
 * Industries where the A4 "Capital Form" layout option is applied.
 *
 * When on, the A4 invoice prints business and Bill To / Ship To name & address in upper case.
 * Other industries ignore the option even if it is present in a saved template.
 */
export const CAPITAL_FORM_INDUSTRIES: number[] = [IndustryType.MOBILE];

export function isCapitalFormEnabledFor(industryId: number | string | null | undefined): boolean {
  return CAPITAL_FORM_INDUSTRIES.includes(Number(industryId));
}

export function isLoyaltyEnabledFor(industryId: number | string | null | undefined): boolean {
  return !LOYALTY_HIDDEN_INDUSTRIES.includes(Number(industryId));
}
